import $ from "jquery";
import { goToByScroll } from "../../../assets/js/lib/content/helper";

/**
 * FAQ item
 *
 * Opent en sluit één vraag. De kop is een button, dus de open-stand staat ook in
 * `aria-expanded` en niet alleen in de klasse.
 */
$("body").on("click tap", ".sb_faq-item_head", function () {
    const $item = $(this).closest(".sb_faq-item");

    if ($item.hasClass("s_is-open")) {
        $item.removeClass("s_is-open");
        $(this).attr("aria-expanded", "false");

        // Remove hash
        window.history.replaceState({}, "", window.location.pathname);
    } else {
        $item.addClass("s_is-open");
        $(this).attr("aria-expanded", "true");

        let item_slug = $item.attr("data-item-slug");

        // Scroll naar het aangeklikte item zelf: een selector op de slug pakt het eerste item met
        // dezelfde titel op de pagina, en dat kan in een ander blok staan.
        goToByScroll($item, 200);

        // // set location hash
        window.location.hash = `#${item_slug}`;
    }
});
